// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import "./inject_jquery";

import "./controllers";
import "./google-analytics";
import "./home";
import "lite-youtube-embed";
